async function addVariantToCart(variantId, card) {
  try {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error('Error HTTP al agregar:', errorText);
      return;
    }

    const data = await res.json();

    // Obtener carrito actualizado
    const cartRes = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    const cartData = await cartRes.json();

    // Disparar evento global (misma lógica que mox_arma_tu_pinta.js)
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cartData }
      })
    );
    

  } catch (err) {
    console.error('Error al agregar al carrito:', err);
  }
}

function openMiniCart() {
  const drawer = document.querySelector('hdt-cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
}

async function refreshCartDrawer() {
  try {
    const currentDrawer = document.querySelector('hdt-cart-drawer');
    const wasOpen =
      currentDrawer &&
      (currentDrawer.hasAttribute('open') ||
        currentDrawer.classList.contains('open'));

    const res = await fetch('/?sections=cart-drawer');
    const sections = await res.json();

    if (!sections['cart-drawer']) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

    const newDrawer = doc.querySelector('hdt-cart-drawer');
    if (!newDrawer || !currentDrawer) return;

    currentDrawer.replaceWith(newDrawer);

    // 🔥 Si estaba abierto, volver a abrirlo
    if (wasOpen && typeof newDrawer.open === 'function') {
      requestAnimationFrame(() => {
        newDrawer.open();
      });
    }
  } catch (error) {
    console.error('Error refrescando el cart drawer:', error);
  }
}

function updateCartCount(cart) {
  if (!cart) return;

  const countEl = document.querySelector('hdt-cart-count');
  if (!countEl) return;

  countEl.textContent = cart.item_count;

  // Mostrar u ocultar según cantidad
  if (cart.item_count > 0) {
    countEl.classList.remove('hdt-hidden');
  } else {
    countEl.classList.add('hdt-hidden');
  }
}

document.addEventListener('click', e => {
  const sizeBtn = e.target.closest('.hover-size-item');
  if (!sizeBtn) return;

  const variantId = sizeBtn.dataset.variantId;
  if (!variantId) return;

  const overlay = sizeBtn.closest('.hover-size-overlay');
  if (overlay) {
    overlay.querySelectorAll('.hover-size-item').forEach(btn => {
      btn.classList.remove('is-active');
    });
    sizeBtn.classList.add('is-active');
  }

  const card = sizeBtn.closest('hdt-card-product');
  addVariantToCart(variantId, card);
});

document.addEventListener('cart:updated', async (e) => {
  const cart = e.detail?.cart;

  updateCartCount(cart);
  await refreshCartDrawer();

  const drawer = document.querySelector('hdt-cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    requestAnimationFrame(() => {
      drawer.open();
    });
  }
});